/**
 * I limiti degli allegati.
 *
 * Un modulo a sé, senza import: `common/utilities.ts` importa `unified`, che è
 * ESM, quindi un modulo di logica pura che ne prendesse i valori non si
 * caricherebbe più nella suite `jest.pure`. Qui c'è **un numero solo** perché
 * chi lo legge deve trovare lo stesso tetto sia nel dialog del task sia nel
 * campo allegato del modello: due copie divergono alla prima modifica, e
 * l'utente si troverebbe due tetti diversi per la stessa cosa.
 */

/**
 * Quanti allegati può avere un processo insieme.
 *
 * Era scritto a mano dentro `TaskDetailDialog` (`> 10`), dove il campo allegato
 * non poteva vederlo.
 */
export const MAX_ATTACHMENTS = 10;
